import React from "react";
import Grid from "@mui/material/Grid";
import type { SxProps, Theme } from "@mui/material/styles";

import { mergeSx } from "@intelligems/ig-theme";

import { useExecutionPanelContext } from "../ExecutionPanelContext";
import { ExecutionPanelTitle } from "./ExecutionPanelTitle";
import { ExecutionPanelCloseButton } from "./ExecutionPanelCloseButton";
import { ExecutionPanelMenu } from "./ExecutionPanelMenu";

interface ExecutionPanelHeaderProps {
  sx?: SxProps<Theme>;
}

export const ExecutionPanelHeader = ({
  sx,
}: ExecutionPanelHeaderProps = {}) => {
  const { getSlot, compact } = useExecutionPanelContext();

  return (
    <Grid
      container
      alignItems="center"
      justifyContent="space-between"
      flexWrap={"nowrap"}
      sx={mergeSx(
        {
          flexShrink: 0,
          height: compact ? 40 : 48,
          px: compact ? 1.5 : 2,
        },
        sx
      )}
    >
      <Grid container columnSpacing={2} flexGrow={1}>
        {getSlot("headerLeft", <ExecutionPanelTitle />)}
      </Grid>
      <Grid container spacing={1} width="auto" alignItems="center">
        {getSlot(
          "headerRight",
          <>
            <ExecutionPanelCloseButton />
            <ExecutionPanelMenu />
          </>
        )}
      </Grid>
    </Grid>
  );
};
